__turbopack_context__.v({
  "agentName": "styles-module__FJaGra__agentName",
  "buttonsContainer": "styles-module__FJaGra__buttonsContainer",
  "message": "styles-module__FJaGra__message",
  "modalContent": "styles-module__FJaGra__modalContent",
});
